/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { CalendarGridBody as CalendarGridBodyCore, type CalendarGridBodyProps as CalendarGridBodyCoreProps, type ContextValue, useContextProps } from 'react-aria-components';

interface CalendarGridBodyProps extends Omit<CalendarGridBodyCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const CalendarGridBodyContext = createContext<ContextValue<CalendarGridBodyProps, HTMLTableSectionElement>>({});

const CalendarGridBody = forwardRef((props: CalendarGridBodyProps, ref: ForwardedRef<HTMLTableSectionElement>) => {
  // @ts-expect-error-next-line - no need to specify the default children
  [props, ref] = useContextProps(props, ref, CalendarGridBodyContext);

  const { style, children, ...coreProps } = props;

  return (
    <CalendarGridBodyCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </CalendarGridBodyCore>
  );
});

const styles = stylex.create({
  base: {
    // eslint-disable-next-line @stylexjs/valid-styles
    ':not(#__unused__) > tr > td:first-child > div': {
      borderBottomLeftRadius: 4,
      borderTopLeftRadius: 4,
    },
    // Currently, there is no other way to style last and first cells. RAC does not disclose the cell index
    // eslint-disable-next-line @stylexjs/valid-styles
    ':not(#__unused__) > tr > td:last-child > div': {
      borderBottomRightRadius: 4,
      borderTopRightRadius: 4,
    },
  },
});

export { CalendarGridBody, CalendarGridBodyContext, type CalendarGridBodyProps };
